import { Component } from '@angular/core'

@Component({
  selector: 'app-authorization-error',
  templateUrl: './authorization-error.component.html',
  host: { class: 'h-full' },
})
export class AuthorizationErrorComponent {}
